import { render, staticRenderFns } from "./JoiningIntro.vue?vue&type=template&id=3c9911bc&scoped=true"
import script from "./JoiningIntro.vue?vue&type=script&lang=js"
export * from "./JoiningIntro.vue?vue&type=script&lang=js"
import style0 from "./JoiningIntro.vue?vue&type=style&index=0&id=3c9911bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9911bc",
  null
  
)

export default component.exports